import { DodoConsent } from './dodo/DodoConsent.js';
import { DodoUser } from './dodo/DodoUser.js';
import { DodoUI } from './dodo/DodoUI.js';

/**
 * @typedef {import('../shared/index.d.ts').DodoUserAgentApi} DodoUserAgentApi
 */
/**
 * @implements {DodoUserAgentApi}
 */
export class Dodo {
  consent = new DodoConsent();

  user = new DodoUser();

  ui = new DodoUI();

  constructor() {
    setTimeout(() => {
      const event = new CustomEvent('dodo-ready');
      document.querySelector('html').dispatchEvent(event);
      console.log('ready');
    }, 0);
  }
}
